import React from 'react'
import Toggle from 'material-ui/Toggle'
import { grey500, red500 } from 'material-ui/styles/colors'
import { map, omit, set } from 'lodash'

import EarlyBirdPricingStrategy from './early-bird'

const styles = {
  errorText: {
    color: red500,
    fontSize: '0.8em'
  },
  label: {
    color: grey500,
    fontSize: '0.8em',
    marginTop: '15px',
    display: 'block'
  }
}

const earlyBird = 'early_bird'
const strategyOptions = [{
  key: earlyBird,
  name: 'Early Bird'
}]

const PricingStrategies = props => {
  const { value: strategies } = props

  const handleStrategyValueChange = strategy => (event, key, value) => {
    set(strategies, `${strategy}.${key}`, value)
    props.onChange(event, strategies)
  }

  const handleToggle = strategy => () => {
    const updatedStrategies = strategies[strategy]
      ? omit(strategies, strategy)
      : { ...strategies, [strategy]: {} }

    props.onChange(null, updatedStrategies)
  }

  const editors = map(strategies, (configuration, strategy) => {
    if (strategy === earlyBird) {
      return (
        <EarlyBirdPricingStrategy
          configuration={configuration}
          onValueChange={handleStrategyValueChange(strategy)}
        />
      )
    } else {
      return (
        <div>
          Unknown pricing strategy {strategy}
        </div>
      )
    }
  })

  return (
    <div>
      <label style={styles.label}>Pricing Strategies</label>
      {strategyOptions.map(({ key, name }) => (
        <Toggle
          key={key}
          label={name}
          labelPosition='right'
          toggled={strategies[key]}
          onToggle={handleToggle(key)}
        />
      ))}

      {editors}

      {props.errorText &&
        <p style={styles.errorText}>{props.errorText}</p>}
    </div>
  )
}

// @ts-ignore
PricingStrategies.propTypes = {
  value: React.PropTypes.object.isRequired,
  errorText: React.PropTypes.string
}

// @ts-ignore
PricingStrategies.defaultProps = {
  value: {}
}

export default PricingStrategies
